module.exports = __webpack_public_path__ + "static/media/New-Paper-Tags.85ff25aa.jpg";